import SwaggerClient from 'swagger-client'

class ApiClient {
  constructor (client, authToken) {
    this.client = client
    this._attachControllers(client)
  }

  static build (options, router) {
    return new Promise((resolve, reject) => {
      SwaggerClient({
        url: options.url,
        requestInterceptor (req) {
          // change url
          const url = req.url.split('//', 2)
          if (url.length > 1 && url[0] !== window.location.protocol) {
            req.url = window.location.protocol + '//' + url[1]
          }
          const authToken = localStorage.getItem(options.tokenLocalStorage)
          if (authToken !== null) {
            req.headers['Authorization'] = authToken
          }
          return req
        },
        responseInterceptor (res) {
          if (res.status === 401) {
            if (typeof router.router !== 'undefined' && typeof router.loginRoute !== 'undefined') {
              router.router.push({name: router.loginRoute, params: {go: -1}})
            }
          }
          return res
        }
      }).then(res => {
        const apiClient = new ApiClient(res, options.authToken)
        resolve(apiClient)
      }).catch(err => {
        reject(err)
      })
    })
  }

  _attachControllers (client) {
    // controllers key
    this.businessTripRequest = client.apis['business-trip-controller']
    this.businessTripRequestEmployee = client.apis['business-trip-employee-controller']
    this.businessTripRequestExpense = client.apis['business-trip-expense-controller']
    this.employee = client.apis['employee-controller']
    this.generic = client.apis['generic-controller']
    this.imposition = client.apis['imposition-controller']
    this.organizationBranch = client.apis['organization-branch-controller']
    this.organization = client.apis['organization-controller']
    this.serial = client.apis['serial-controller']
    this.tripExpense = client.apis['trip-expense-controller']
    this.dashboard = client.apis['dashboard-controller']
    this.approvalType = client.apis['approval-type-controller']
    this.approval = client.apis['approval-controller']
    this.dataAudit = client.apis['data-audit-trail-controller']
    this.home = client.apis['home-controller']
    this.btRealization = client.apis['business-trip-realization-controller']
    this.btRealizationExpense = client.apis['business-trip-realization-expense-controller']
    this.report = client.apis['report-controller']
    this.upload = client.apis['upload-controller']
  }
}

export default ApiClient



// WEBPACK FOOTER //
// ./src/api/Client.js